import React from 'react'
import ContactDetails from './contactDetails'

const FlightDealsBanner = ({ isFormVisible, handleFormVisibility }) => {
  return (
    <div className='row'>
      <div className='col-md-12'>
        <div className='call_us_banner'>
          Get Great Flight Prices from Our Travel Experts
        </div>
      </div>
      <div className='col-md-12 text-center'>
        <ContactDetails />
        <div className='sa-or'>or</div>
        <button
          type='button'
          className='btn btn-rqust sa-clnowbtn'
          id='rqstCall'
          onClick={handleFormVisibility}
        >
          {isFormVisible ? 'Hide Form' : 'Get a Call'}
        </button>
      </div>
    </div>
  )
}

export default FlightDealsBanner
